<template>
  <div class="icome_information--block">
    <div class="block_above">
      <div class="salary_chart_information">
        <el-card>
          <div slot="header">
            <p class="title_header mb-4">Chọn giai đoạn</p>
            <div>
              <el-form ref="chooseStageForm" :model="dataSearch" label-width="71px">
                <el-row :gutter="15">
                  <el-col :md="12" :lg="9">
                    <el-form-item label="Từ kỳ">
                      <el-select
                        ref="fromPeriod"
                        v-model="dataSearch.fromPeriod"
                        placeholder="Từ kỳ"
                        clearable
                        @change="checkFromPeriod"
                      >
                        <el-option
                          v-for="item in dataDefault.listSalaryPeriods"
                          :key="item.id"
                          :label="item.name_period"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12" :lg="9">
                    <el-form-item label="đến kỳ">
                      <el-select
                        ref="toPeriod"
                        v-model="dataSearch.toPeriod"
                        placeholder="Đến kỳ"
                        clearable
                        @change="checkToPeriod"
                      >
                        <el-option
                          v-for="item in dataDefault.listSalaryPeriods"
                          :key="item.id"
                          :label="item.name_period"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :md="24" :lg="6">
                    <el-button type="primary" @click="submit">Áp dụng</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div>
            <el-tabs
              type="card"
              v-model="activeTab"
              @tab-click="handleClick"
              :class="{
                'open-menu': showMenu,
                'mini-menu': !showMenu,
              }"
            >
              <el-tab-pane name="salaryInformation">
                <div slot="label" class="label-custom">
                  <i class="icon icon24-Thongke"></i>
                  <span> Thông tin lương, thù lao</span>
                </div>
                <Salary
                  :fromPeriodProp='fromPeriodProp'
                  :toPeriodProp='toPeriodProp'
                  :listSalaryPeriod='dataDefault.listSalaryPeriods'
                  :haveSalaryPeriod="haveSalaryPeriod"
                  :keySubmit="keySubmit"
                />
              </el-tab-pane>
              <el-tab-pane label="Thuế đã thu/Đã kê khai, Công nợ" name="tax">
                <div slot="label" class="label-custom">
                  <i class="icon icon24-StickyNote"></i>
                  <span> Thuế đã thu/Đã kê khai, Công nợ</span>
                </div>
                <Tax
                  :fromPeriodProp='fromPeriodProp'
                  :toPeriodProp='toPeriodProp'
                  :listSalaryPeriod='dataDefault.listSalaryPeriods'
                  :keySubmit="keySubmit"
                />
              </el-tab-pane>
              <el-tab-pane label="Trích nộp bảo hiểm" name="insurance">
                <div slot="label" class="label-custom">
                  <i class="icon icon24-Wallet"></i>
                  <span>Trích nộp bảo hiểm</span>
                </div>
                <Insurance
                  :fromPeriodProp='fromPeriodProp'
                  :toPeriodProp='toPeriodProp'
                  :listSalaryPeriod='dataDefault.listSalaryPeriods'
                  :keySubmit="keySubmit"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </div>
      <div class="timekeeping_information">
        <el-card>
          <div slot="header">
            <p class="title_header">Thông tin chấm công</p>
          </div>
          <div class="calendar_block">
            <Calendar />
          </div>
          <div class="notification_block">
            <p class="title">Thông báo hệ thống</p>
            <div class="notification_block--list">
              <Notification />
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="block_below">
      <div class="block_below--header">
        <div class="select-period">
          <el-select v-model="salaryPeriodDetailView" @change="getDetailSalaryBySalaryPeriod">
            <el-option
              v-for="item in dataDefault.listSalaryPeriods"
              :key="item.id"
              :label="item.name_period"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="button-group">
          <el-button type="primary" class="btn-view" @click="goToDetailSalary">
            <i class="icon icon24-EyeOn"></i>
            <span>Xem chi tiết</span>
          </el-button>
          <el-button type="primary" class="btn-export" @click="exportPaycheck">
            <i class="icon icon24-Download"></i>
            <span>Tải phiếu lương</span>
          </el-button>
        </div>
      </div>
      <div class="block_below--body">
        <el-table
          :data="dataTable"
          style="width: 100%"
        >
          <el-table-column
            label="Kỳ chấm công"
          >
            <el-table-column
              :label="`Kỳ ${getSalaryPeriodName(salaryPeriodDetailView)}`"
            >
              <el-table-column
                label="Từ ngày"
                width="120"
                align="center"
              >
                <template>
                  {{ MethodService.formatDate(getStartTimePeriod(salaryPeriodDetailView), 'date') }}
                </template>
              </el-table-column>
              <el-table-column
                label="Đến ngày"
                width="120"
                align="center"
              >
                <template>
                  {{ MethodService.formatDate(MethodService.getLastDayOfMonth(getStartTimePeriod(salaryPeriodDetailView)), 'date') }}
                </template>
              </el-table-column>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="Ngày công"
          >
            <el-table-column
              label="Chi tiết ngày công"
            >
              <el-table-column
                prop="totalStandardWork"
                label="Công chuẩn"
                width="120"
                align="center"
              />
              <el-table-column
                prop="totalWork"
                label="Công thực tế"
                width="120"
                align="center"
              />
              <el-table-column
                prop="totalPaidLeave"
                label="Ngày nghỉ hưởng lương"
                width="120"
                align="center"
              />
              <el-table-column
                prop="totalUnpaidLeave"
                label="Ngày nghỉ không hưởng lương"
                width="120"
                align="center"
              />
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="Chi tiết thu nhập"
          >
            <el-table-column
              v-for="(value, key) in myObject"
              :key="key"
              :label='key'
              align="right"
            >
            {{ value !== undefined && value !== null && value !== ''
              ? MethodService.formatCurrency(parseInt(value) || 0)
              : undefined }}
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from '../../../service/MethodService'
import SalaryPeriodApi from '@/moduleApi/SalaryPeriodApi'
import SalaryApi from '@/moduleApi/SalaryApi'
import WorkApi from '@/moduleApi/WorkApi'
import ShiftApi from '@/moduleApi/ShiftApi'
import EmployeeShiftApi from '@/moduleApi/EmployeeShiftApi'
import EmployeeRequestApi from '@/moduleApi/EmployeeRequestApi'
import Calendar from '@/component/Calendar'
import Notification from '@/component/Notification_Card'
import Salary from './components/Salary'
import Tax from './components/Tax'
import Insurance from './components/Insurance'
import toastr from 'toastr'
import { Filter } from 'mushroomjs'
import EventBus from "@/service/EventBus"
export default {
  components: {
    Calendar,
    Notification,
    Salary,
    Tax,
    Insurance,
  },
  data() {
    return {
      MethodService,
      activeTab: 'salaryInformation',
      keySubmit: undefined,
      fromPeriodProp: undefined,
      toPeriodProp: undefined,
      myObject: undefined,
      haveSalaryPeriod: true,
      salaryPeriodDetailView: undefined,
      currentUser: MethodService.getCurrentUser(),
      dataTable: [],
      showMenu: false,
      dataSearch: {
        filter: "",
        fromPeriod: undefined,
        toPeriod: undefined,
      },
      dataDefault: {
        listSalaryPeriods: []
      }
    }
  },
  methods: {
    // Getting the list of salary periods for the current user.
    async getPersonalSalary() {
      let arrSalaryPeriodIds = []
      const salaryApiRes = await SalaryApi.list({
        filters: `employee_id=$$user_id&sealed=true`,
        fields: 'salary_period_id',
        limit: 1000
      })
      arrSalaryPeriodIds = MethodService.findListItemDifferent(salaryApiRes.result, 'salary_period_id')
      if (arrSalaryPeriodIds.length == 0) this.haveSalaryPeriod = false
      this.getListSalaryPeriod(arrSalaryPeriodIds)
    },
    // The above code is used to get the data of the employee's salary in the selected period.
    async getDetailSalaryBySalaryPeriod() {
      this.repalceRouter()
      this.dataTable = []
      this.myObject = undefined
      let filter = `salary_period_id=${this.salaryPeriodDetailView}&employee_id=$$user_id`
      let filterEmployeeShift = Filter.and(
        Filter.eq('employee_id', '$$user_id'),
        Filter.lte('start_time', MethodService.getLastDayOfMonth(this.getStartTimePeriod(this.salaryPeriodDetailView)).toISOString()),
        Filter.or(
          Filter.isNull('end_time'),
          Filter.gte('end_time', MethodService.getFirstDayOfMonth(this.getStartTimePeriod(this.salaryPeriodDetailView)).toISOString())
        )
      ).build()
      const salaryApiRes = await SalaryApi.list({
        filters: filter,
        fields: 'custom_fields,company_id,employee_id,employee_no'
      })
      const workApiRes = await WorkApi.list({
        filters: filter,
        limit: 1000,
        fields: 'work_value,shift_id'
      })
      const employeeShift = await EmployeeShiftApi.list({
        filters: filterEmployeeShift
      })
      const salary = salaryApiRes.result && salaryApiRes.result[0]
      let mealDeduction = 0
      if (salary) {
        try {
          const payrollApiRes = await SalaryApi.GetCompanyPayroll({
            salary_period_id: this.salaryPeriodDetailView,
            company_id: salary.company_id,
            condition: salary.employee_no || ''
          })
          const payrollRows = payrollApiRes && payrollApiRes.result && Array.isArray(payrollApiRes.result.rows)
            ? payrollApiRes.result.rows
            : []
          const payrollRow = payrollRows.find(item =>
            item.employee_id === salary.employee_id ||
            (salary.employee_no && item.employee_no === salary.employee_no)
          )
          mealDeduction = payrollRow && payrollRow.meal_deduction !== undefined
            ? payrollRow.meal_deduction
            : 0
        } catch (error) {
          // Keep the personal salary table available if the calculated payroll API fails.
          mealDeduction = 0
        }
      }
      let totalWork = 0
      let totalStandardWork = 0
      let totalPaidLeave = 0
      let totalUnpaidLeave = 0
      workApiRes.result.forEach(work => totalWork += work.work_value)
      let arrShiftIds = MethodService.findListItemDifferent(employeeShift.result, 'shift_id')
      let promises = []
      arrShiftIds.forEach(e => {
        promises.push(
          ShiftApi.CalcStandardWork({
            shiftId: e,
            formDate: MethodService.getFirstDayOfMonth(this.getStartTimePeriod(this.salaryPeriodDetailView)),
            toDate: MethodService.getLastDayOfMonth(this.getStartTimePeriod(this.salaryPeriodDetailView))
          })
        )
        promises.push(
          EmployeeRequestApi.CalcNumberOfDayOffOfEmployee({
            employee_id: this.currentUser.id,
            from_date: MethodService.getFirstDayOfMonth(this.getStartTimePeriod(this.salaryPeriodDetailView)),
            to_date: MethodService.getLastDayOfMonth(this.getStartTimePeriod(this.salaryPeriodDetailView)),
            shift_id: e
          })
        )
      })
      Promise.all(promises).then(res => {
        this.keySubmit = MethodService.generateId(30)
        res.forEach(x => {
          if (x.result.standardWork) totalStandardWork += x.result.standardWork
          if (x.result.dayOffHasSalaryCount) totalPaidLeave += x.result.dayOffHasSalaryCount
          if (x.result.dayOffHasNoSalaryCount) totalUnpaidLeave += x.result.dayOffHasNoSalaryCount
        })
        let obj = this.buildIncomeDetailColumns(
          salary && salary.custom_fields,
          mealDeduction
        )
        let dataDefault = {
          totalWork: MethodService.mathRound(totalWork),
          totalStandardWork: MethodService.mathRound(totalStandardWork),
          totalPaidLeave: totalPaidLeave,
          totalUnpaidLeave: totalUnpaidLeave,
        }
        this.dataTable.push(dataDefault)
        this.myObject = obj
      })
    },
    normalizeIncomeColumnKey(value) {
      return MethodService.changeAlias(`${value || ''}`)
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '')
    },
    buildIncomeDetailColumns(customFields, mealDeduction) {
      const fields = Array.isArray(customFields) ? customFields : []
      const mealDeductionAliases = new Set([
        'khautrutienan',
        'mealdeduction'
      ])
      const insertBeforeAliases = new Set([
        'tamung',
        'advance',
        'khac',
        'khoangiamtrukhac',
        'tongluongthucnhan',
        'tongluongthuclinh'
      ])
      const result = {}
      let hasMealDeduction = false

      const appendMealDeduction = () => {
        if (hasMealDeduction) return
        result['Khấu trừ tiền ăn'] = mealDeduction
        hasMealDeduction = true
      }

      fields.forEach((item, index) => {
        if (index === 0 || index === 1 || !item) return
        const normalizedKey = this.normalizeIncomeColumnKey(item.key)
        if (mealDeductionAliases.has(normalizedKey)) {
          appendMealDeduction()
          return
        }
        if (insertBeforeAliases.has(normalizedKey)) {
          appendMealDeduction()
        }
        result[item.key] = item.value
      })

      appendMealDeduction()
      return result
    },
    // Calling the API to get the list of salary periods.
    async getListSalaryPeriod(arrSalaryPeriodIds) {
      const salaryPeriodApiRes = await SalaryPeriodApi.list({
        filters: `id:in:${arrSalaryPeriodIds.join(',')}`,
        limit: arrSalaryPeriodIds.length,
        fields: 'id,name,from_date,before_to_date',
        sort: '-id'
      })
      if (salaryPeriodApiRes.result && salaryPeriodApiRes.result.length > 0) {
        this.dataDefault.listSalaryPeriods = this.changeData(salaryPeriodApiRes.result)
        if (!this.salaryPeriodDetailView) {
          this.salaryPeriodDetailView = salaryPeriodApiRes.result[0].id
        }
        this.getDetailSalaryBySalaryPeriod()
        if (!this.dataSearch.fromPeriod && !this.dataSearch.toPeriod) {
          this.fromPeriodProp = this.dataSearch.fromPeriod = salaryPeriodApiRes.result[0].id
          this.toPeriodProp = this.dataSearch.toPeriod = salaryPeriodApiRes.result[0].id
        }
        this.repalceRouter()
      } else {
        this.myObject = {
          'Không có thông tin lương' : ''
        }
      }
    },
    // Changing the name of the period to MM/YYYY
    changeData(data) {
      data.forEach(item => {
        item.name_period = this.changeNameSalaryPeriodToMMYYYY(item.from_date)
      })
      return data
    },
    // A function to change the name of the period to the format MM/YYYY.
    changeNameSalaryPeriodToMMYYYY(name) {
      let month = new Date(name).getMonth() + 1
      let year = new Date(name).getFullYear()
      return `Tháng ${month}/${year}`
    },
    // A method that is called when a tab is clicked. It sets the activeTab to the name of the tab that
    // was clicked. It then calls the replaceRouter method.
    handleClick(tab) {
      this.activeTab = tab.name
      this.keySubmit = MethodService.generateId(30)
      this.repalceRouter()
    },
    // A method that is called when the user clicks the submit button.
    async submit() {
      this.repalceRouter()
      if (!this.dataSearch.fromPeriod) {
        toastr.warning('Vui lòng chọn "Từ kỳ"')
        return
      }
      if (!this.dataSearch.toPeriod) {
        toastr.warning('Vui lòng chọn "Đến kỳ"')
        return
      }
      this.fromPeriodProp = this.dataSearch.fromPeriod
      this.toPeriodProp = this.dataSearch.toPeriod
      this.keySubmit = MethodService.generateId(30)
    },
    // Replacing the current route with a new route.
    repalceRouter() {
      this.$router.replace({
        name: 'Admin-Income-Information',
        query: {
          currentPeriodView: this.salaryPeriodDetailView,
          fromPeriod: this.dataSearch.fromPeriod,
          toPeriod: this.dataSearch.toPeriod,
          tab: this.activeTab,
        }
      }).catch(() => {})
    },
    // A method that is used to get the start time period of a salary period.
    getStartTimePeriod(id) {
      let period = this.dataDefault.listSalaryPeriods.find(e => e.id == id)
      return period && period.from_date ? period.from_date : undefined
    },
    // A method that is used to get the name of the salary period.
    getSalaryPeriodName(id) {
      let period = this.dataDefault.listSalaryPeriods.find(e => e.id == id)
      return period && period.name_period ? period.name_period.toLowerCase() : ''
    },
    // The above code is checking if the fromPeriod is greater than toPeriod. If it is, it will show a
    // warning message and clear the fromPeriod.
    checkFromPeriod() {
      if (!this.dataSearch.toPeriod) return
      let startTimeFromPeriod = this.getStartTimePeriod(this.dataSearch.fromPeriod)
      let startTimeToPeriod = this.getStartTimePeriod(this.dataSearch.toPeriod)
      if (new Date(startTimeFromPeriod).getTime() > new Date(startTimeToPeriod).getTime()) {
        toastr.warning(`Thời gian "Từ kỳ" bé hơn hoặc bằng "Tới kỳ"`)
        this.dataSearch.fromPeriod = undefined
        setTimeout(() => {
          this.$refs.fromPeriod.focus()
        }, 1000)
      }
    },
    // Checking if the fromPeriod is greater than toPeriod. If it is, it will show a warning message
    // and clear the toPeriod.
    checkToPeriod() {
      if (!this.dataSearch.fromPeriod) return
      let startTimeFromPeriod = this.getStartTimePeriod(this.dataSearch.fromPeriod)
      let startTimeToPeriod = this.getStartTimePeriod(this.dataSearch.toPeriod)
      if (new Date(startTimeFromPeriod).getTime() > new Date(startTimeToPeriod).getTime()) {
        toastr.warning(`Thời gian "Từ kỳ" bé hơn hoặc bằng "Tới kỳ"`)
        this.dataSearch.toPeriod = undefined
        setTimeout(() => {
          this.$refs.toPeriod.focus()
        }, 1000)
      }
    },
    // The above code is used to redirect to another page.
    goToDetailSalary(){
      this.$router.push({
        name: 'Admin-SalaryEmployee-list',
        query: {
          salary_period_id: this.salaryPeriodDetailView,
          tab: 'Salary'
        }
      }).catch(() => {})
    },
    exportPaycheck() {
      MethodService.exportPersonalSalary(
        this.dataTable,
        this.getSalaryPeriodName(this.salaryPeriodDetailView),
        MethodService.formatDate(this.getStartTimePeriod(this.salaryPeriodDetailView), 'date'),
        MethodService.formatDate(MethodService.getLastDayOfMonth(this.getStartTimePeriod(this.salaryPeriodDetailView)), 'date'),
        this.myObject
      )
    },
    // Checking if the query string has a fromPeriod and toPeriod. If it does, it sets the
    // dataSearch.fromPeriod and dataSearch.toPeriod to the query string values. It then calls the
    // submit() function.
    fn_hashUrl() {
      if (this.$route.query.currentPeriodView) this.salaryPeriodDetailView = this.$route.query.currentPeriodView
      if (this.$route.query.fromPeriod && this.$route.query.toPeriod) {
        this.fromPeriodProp = this.dataSearch.fromPeriod = this.$route.query.fromPeriod
        this.toPeriodProp = this.dataSearch.toPeriod = this.$route.query.toPeriod
        this.submit()
      }
    },
  },
  created() {
    this.fromPeriodProp = 'default'
    this.toPeriodProp = 'default'
    if (this.$route.query.tab) this.activeTab = this.$route.query.tab
    EventBus.$off('changeSizeMenu')
    EventBus.$on('changeSizeMenu', (data) => {
      this.showMenu = data
    })
  },
  mounted() {
    this.fn_hashUrl()
    this.getPersonalSalary()
  }
}
</script>

<style lang="scss" scoped>
h1, h2, h3, h4, h5, h6, p, span {
  font-family: 'LexendDeca Regular' !important;
}
::v-deep .el-card {
  .el-card__header {
    .title_header {
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 0;
  .el-form-item__label {
    text-align: left;
    font-family: 'LexendDeca Regular' !important;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #292D32;
    margin-bottom: 0;
    padding-top: 5px;
  }
}
::v-deep .salary_chart_information {
  .el-card {
    .el-card__header {
      padding-right: 60px;
    }
  }
  .el-button {
    width: 100%;
  }
}
::v-deep .el-button{
  &.btn-export {
    width: 240px;
    background: linear-gradient(98.36deg, #F69D61 7.34%, #FB6B5F 96.09%) !important;
    border-radius: 4px !important;
  }
  &.btn-view {
    width: 240px;
    background: #FFFFFF !important;
    border-radius: 4px !important;
    span {
      color: #fb8274 ;
    }
  }
  span {
    font-family: 'LexendDeca Regular' !important;
  }
  .icon {
    margin-right: 15px;
  }
}

::v-deep .el-tabs--card>.el-tabs__header {
  border-bottom: none;
}
::v-deep .el-tabs {
  .el-tabs__header {
    .el-tabs__nav {
      display: flex;
      .el-tabs__item {
        margin-right: 0;
        background: #E9E9E9;
        border-radius: 0;
        border-bottom: 3px solid #D0D5D9;
        height: 50px;
        display: flex;
        padding: 0;
        .label-custom {
          display: flex;
          align-items: center;
          margin: 8px 0;
          padding: 0 20px;
          // &:not(:last-child) {
            // border-right: 1px solid #000000;
          // }
          color: #292D32;
          .icon {
            margin-right: 10px
          }
          span {
            color: #292D32;
            font-weight: 300;
            font-size: 15px;
            line-height: 24px;
          }
        }
        &:nth-child(2) {
          padding-left: 0;
          .label-custom {
            border-right: 1px solid #000000;
            border-left: 1px solid #000000;
          }
        }
        &:last-child {
          padding-right: 0;
        }
        &.is-active {
          background-color: #FFFFFF !important;
          border: none;
          border-top: 3px solid #F79E61;
          .label-custom {
            border: none;
          }
        }
      }
    }
  }
  .el-tabs__content {
    min-height: 600px;
    padding: 10px 20px;
    position: relative;
  }
}
::v-deep .el-table {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: none;
  thead {
    tr {
      th {
        background: #FFFFFF !important;
        color: #444242;
      }
      &:first-child {
        th {
          background: #4F8AAB !important;
          color: #FFFFFF;
        }
      }
    }
  }
}
.icome_information--block {
  .block_above {
    display: grid;
    grid-gap: 25px;
    grid-template-columns: 1fr 400px;
    .salary_chart_information {
      .el-button {
        width: 100%;
        background: #4F8AAB !important;
        border-radius: 4px !important;
        border-color: #4F8AAB !important;

      }
    }
    .timekeeping_information {
      .notification_block {
        padding-top: 12px;
        border-top: 1px solid #D0D5D9;
        .title {
          font-weight: 400;
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 5px;
        }
        &--list {
          height: 415px;
          overflow: auto;
        }
      }
    }
  }
  .block_below {
    margin-top: 15px;
    &--header {
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .select-period {
        ::v-deep .el-input__inner {
          width: 215px;
          background: transparent;
          border: none;
          box-shadow: none;
          font-weight: 600;
          font-size: 22px;
          line-height: 32px;
          color: #292D32;
        }
        ::v-deep .el-input__suffix {
          .el-icon-arrow-up:before {
            font-weight: 900;
            font-size: 18px;
          }
        }
      }
    }
    &--body {
      margin-bottom: 10px;
      .el-table {
      }
    }
  }
}
@media (max-width: 1400px) {
  ::v-deep .el-tabs--card.mini-menu>.el-tabs__header {
    width: 700px;
  }
  ::v-deep .el-tabs--card.open-menu>.el-tabs__header {
    width: 580px;
  }
}

@media (max-width: 767px) {
  ::v-deep .el-card {
    .el-card__header,
    .el-card__body {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  ::v-deep .salary_chart_information {
    .el-card {
      .el-card__header {
        padding-right: 15px;
      }
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 12px;

    .el-form-item__content {
      line-height: 40px;
    }
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-tabs--card.mini-menu>.el-tabs__header,
  ::v-deep .el-tabs--card.open-menu>.el-tabs__header {
    width: auto;
  }

  ::v-deep .el-tabs {
    .el-tabs__header {
      overflow-x: auto;
      overflow-y: hidden;
      margin-bottom: 0;

      .el-tabs__nav {
        width: max-content;
        min-width: 100%;
      }
    }

    .el-tabs__content {
      min-height: 0;
      padding: 10px 0 0;
      overflow: visible;
    }
  }

  ::v-deep #turnover {
    height: 470px !important;
  }

  .icome_information--block {
    .block_above {
      grid-template-columns: 1fr;
      grid-gap: 15px;
      min-width: 0;

      .salary_chart_information,
      .timekeeping_information {
        min-width: 0;
      }

      .timekeeping_information {
        .calendar_block {
          overflow: hidden;

          ::v-deep .vc-container {
            width: 100%;
            min-width: 0;
          }
        }

        .notification_block {
          min-width: 0;

          &--list {
            height: auto;
            max-height: none;
            overflow: visible;

            ::v-deep .list-noti--item {
              grid-template-columns: 50px minmax(0, 1fr);
            }

            ::v-deep .content {
              min-width: 0;
            }
          }
        }
      }
    }

    .block_below {
      &--header {
        align-items: stretch;
        flex-direction: column;
        gap: 12px;

        .select-period {
          ::v-deep .el-input__inner {
            width: 100%;
          }
        }

        .button-group {
          display: flex;
          flex-direction: column;
          gap: 10px;

          ::v-deep .el-button {
            width: 100%;
            margin-left: 0;
          }
        }
      }

      &--body {
        overflow-x: auto;
        padding-bottom: 4px;

        ::v-deep .el-table {
          min-width: 760px;
          height: auto !important;
          max-height: none !important;
        }

        ::v-deep .el-table__body-wrapper {
          max-height: none !important;
          overflow-y: visible !important;
        }
      }
    }
  }

  ::v-deep .table__block {
    min-height: 0;

    .el-table {
      height: auto !important;
      max-height: none !important;
    }

    .el-table__body-wrapper {
      max-height: none !important;
      overflow-y: visible !important;
    }
  }
}
</style>
